import { post, get, request } from "./http.js";
//公共接口
/**
 * 登录
 * @param {*} data 
 * @returns 
 */
const indexLogin = (data) => post("platform/index/login", data);
/**
 * 发送验证码
 * @param {*} data 
 * @returns 
 */
const indexSendcode = (data) => post("platform/index/sendcode", data);
/**
 * 忘记密码
 * @param {*} data 
 * @returns 
 */
const indexReset = (data) => post("platform/index/reset", data);
/**
 * 上传图片
 * @param {*} data 
 * @returns 
 */
const indexUploadimg = (data) => post("platform/index/uploadimg", data);
/**
 * 上传文件
 * @param {*} data 
 * @returns 
 */
const indexUploadfile = (data) => post("platform/index/uploadfile", data);
/**
 * 得到当前账户信息
 * @param {*} data 
 * @returns 
 */
const indexGetinfo = (data) => post("platform/index/getinfo", data);
/**
 * 编辑当前账号信息
 * @param {*} data 
 * @returns 
 */
const indexEditinfo = (data) => post("platform/index/editinfo", data);
/**
 * 登录日志
 * @param {*} data 
 * @returns 
 */
const indexLoginlog = (data) => post("platform/index/loginlog", data);

/**
 * 活动管理-列表
 * @param {*} data 
 * @returns 
 */
const activityActivitylist = (data) => post("platform/activity/activitylist", data);
/**
 * 活动管理-活动详情
 * @param {*} data 
 * @returns 
 */
const activityActivitydetail = (data) => post("platform/activity/activitydetail", data);
/**
 * 活动管理-新增编辑活动
 * @param {*} data 
 * @returns 
 */
const activityActivityedit = (data) => post("platform/activity/activityedit", data);
/**
 * 活动管理-新增编辑班级
 * @param {*} data 
 * @returns 
 */
const activityBanjiedit = (data) => post("platform/activity/banjiedit", data);
/**
 * 活动管理-班级列表
 * @param {*} data 
 * @returns 
 */
const activityBanjilist = (data) => post("platform/activity/banjilist", data);
/**
 * 活动管理-班级详情
 * @param {*} data 
 * @returns 
 */
const activityBanjidetail = (data) => post("platform/activity/banjidetail", data);
/**
 * 活动管理-删除班级
 * @param {*} data 
 * @returns 
 */
const activityBanjidel = (data) => post("platform/activity/banjidel", data);
/**
 * 活动管理-新增编辑课程
 * @param {*} data 
 * @returns 
 */
const activityCourseedit = (data) => post("platform/activity/courseedit", data);
/**
 * 活动管理-课程详情
 * @param {*} data 
 * @returns 
 */
const activityCoursedetail = (data) => post("platform/activity/coursedetail", data);
/**
 * 活动管理-课程列表
 * @param {*} data 
 * @returns 
 */
const activityCourselist = (data) => post("platform/activity/courselist", data);
/**
 * 活动管理-得到讲师列表
 * @param {*} data 
 * @returns 
 */
const activityGetteacher = (data) => post("platform/activity/getteacher", data);
/**
 * 活动管理-删除课程
 * @param {*} data 
 * @returns 
 */
const activityCoursedel = (data) => post("platform/activity/coursedel", data);
/**
 * 活动管理-当前活动下的所有分组
 * @param {*} data 
 * @returns 
 */
const activityGrouplist = (data) => post("platform/activity/grouplist", data);
/**
 * 活动管理-根据班级数量生成分组（活动还在创建中时，根据 是否可以报多班 参数值为 不可以时 自动生成分组）
 * @param {*} data 
 * @returns 
 */
const activitySetgroup = (data) => post("platform/activity/setgroup", data);
/**
 * 活动管理-编辑新增分组
 * @param {*} data 
 * @returns 
 */
const activityGroupedit = (data) => post("platform/activity/groupedit", data);
/**
 * 活动管理-删除分组
 * @param {*} data 
 * @returns 
 */
const activityGroupdel = (data) => post("platform/activity/groupdel", data);
/**
 * 活动管理-移除班级 (将当前班级解绑分组)
 * @param {*} data 
 * @returns 
 */
const activityUnbindbanji = (data) => post("platform/activity/unbindbanji", data);
/**
 * 移动班级（将当前班级的分组移动到其他分组）
 * @param {*} data 
 * @returns 
 */
const activityMovebanji = (data) => post("platform/activity/movebanji", data);
/**
 * 活动管理-保存活动 (活动状态变为待发布)
 * @param {*} data 
 * @returns 
 */
const activitySaveactivity = (data) => post("platform/activity/saveactivity", data);
/**
 * 活动管理-发布活动
 * @param {*} data 
 * @returns 
 */
const activityReleaseactivity = (data) => post("platform/activity/releaseactivity", data);
/**
 * 活动管理-重新发布(已结束的活动重新发布，复制一份出来，活动时间重新设置)
 * @param {*} data 
 * @returns 
 */
const activityAgainreleaseactivity = (data) => post("platform/activity/againreleaseactivity", data);
/**
 * 活动管理-删除活动 （只有待发布的活动才能删除）
 * @param {*} data 
 * @returns 
 */
const activityActivitydel = (data) => post("platform/activity/activitydel", data);
/**
 * 活动管理-得到活动类型
 * @param {*} data 
 * @returns 
 */
const dictionaryGetactivitytype = (data) => post("platform/dictionary/getactivitytype", data);
/**
 * 活动管理-得到班级类型
 * @param {*} data 
 * @returns 
 */
const dictionaryGetbanjitype = (data) => post("platform/dictionary/getbanjitype", data);
/**
 * 创建分组页面的班级列表
 * @param {*} data 
 * @returns 
 */
const activityGroupbanjilist = (data) => post("platform/activity/groupbanjilist", data);
/**
 * 得到已报名人员中的邀请人下拉
 * @param {*} data 
 * @returns 
 */
const activityGetinvite = (data) => post("platform/activity/getinvite", data);
/**
 * 活动报名人员列表
 * @param {*} data 
 * @returns 
 */
const activitySignupuserlist = (data) => post("platform/activity/signupuserlist", data);
/**
 * 批量导入报名人员
 * @param {*} data 
 * @returns 
 */
const activityImportsignup = (data) => post("platform/activity/importsignup", data);
/**
 * 批量代签到
 * @param {*} data 
 * @returns 
 */
const activitySetusercheckin = (data) => post("platform/activity/setusercheckin", data);
/**
 * 得到取消报名原因
 * @param {*} data 
 * @returns 
 */
const dictionaryGetcancelreason = (data) => post("platform/dictionary/getcancelreason", data);
/**
 * 取消报名（待签到未签到状态可以操作）
 * @param {*} data 
 * @returns 
 */
const activityCancelsignup = (data) => post("platform/activity/cancelsignup", data);
/**
 * 生成活动签到二维码
 * @param {*} data 
 * @returns 
 */
const activitySetqrcode = (data) => post("platform/activity/setqrcode", data);
/**
 * 批量导入报名人员2
 * @param {*} data 
 * @returns 
 */
const activityImportsignupnew = (data) => post("platform/activity/importsignup2", data);

//活动任务
/**
 * 活动任务-列表
 * @param {*} data 
 * @returns 
 */
const activityTasklist = (data) => post("platform/activity/tasklist", data);
/**
 * 活动任务-新增任务
 * @param {*} data 
 * @returns 
 */
const activityTaskadd = (data) => post("platform/activity/taskadd", data);
/**
 * 活动任务-根据任务id获取任务人员
 * @param {*} data 
 * @returns 
 */
const activityTaskuserlist = (data) => post("platform/activity/taskuserlist", data);
/**
 * 活动任务-删除活动人员任务
 * @param {*} data 
 * @returns 
 */
const activityUsertasklogdel = (data) => post("platform/activity/usertasklogdel", data);
/**
 * 活动任务-批量编辑个人任务
 * @param {*} data 
 * @returns 
 */
const activityEditusertasklog = (data) => post("platform/activity/editusertasklog", data);
/**
 * 活动任务-邀请人列表
 * @param {*} data 
 * @returns 
 */
const activityInvitelog = (data) => post("platform/activity/invitelog", data);

//会员管理
/**
 * 会员管理-会员列表
 * @param {*} data 
 * @returns 
 */
const userUserlist = (data) => post("platform/user/userlist", data);
/**
 * 会员管理-新增编辑会员
 * @param {*} data 
 * @returns 
 */
const userUseredit = (data) => post("platform/user/useredit", data);
/**
 * 会员管理-会员详情
 * @param {*} data 
 * @returns 
 */
const userUserdetail = (data) => post("platform/user/userdetail", data);
/**
 * 会员管理-删除会员
 * @param {*} data 
 * @returns 
 */
const userUserdel = (data) => post("platform/user/userdel", data);
/**
 * 会员管理-会员身份列表
 * @param {*} data 
 * @returns 
 */
const userRolelist = (data) => post("platform/user/rolelist", data);
/**
 * 会员管理-新增编辑身份
 * @param {*} data 
 * @returns 
 */
const userRoleedit = (data) => post("platform/user/roleedit", data);
/**
 * 会员管理-删除身份
 * @param {*} data 
 * @returns 
 */
const userRoledel = (data) => post("platform/user/roledel", data);
/**
 * 会员管理-得到所属分组
 * @param {*} data 
 * @returns 
 */
const dictionaryGetgroup = (data) => post("platform/dictionary/getgroup", data);
/**
 * 会员管理-得到所有的系统权限
 * @param {*} data 
 * @returns 
 */
const userGetallmenu = (data) => post("platform/user/getallmenu", data);
/**
 * 会员管理-给相应角色分配菜单权限
 * @param {*} data 
 * @returns 
 */
const userSetmenu = (data) => post("platform/user/setmenu", data);

//轮播管理
/**
 * 轮播管理-列表
 * @param {*} data 
 * @returns 
 */
const bannerLst = (data) => post("platform/banner/lst", data);
/**
 * 轮播管理-新增编辑
 * @param {*} data 
 * @returns 
 */
const bannerEdit = (data) => post("platform/banner/edit", data);
/**
 * 轮播管理-启用禁用
 * @param {*} data 
 * @returns 
 */
const bannerChangestatus = (data) => post("platform/banner/changestatus", data);
/**
 * 轮播管理-删除
 * @param {*} data 
 * @returns 
 */
const bannerDel = (data) => post("platform/banner/del", data);
/**
 * 轮播管理-详情
 * @param {*} data 
 * @returns 
 */
const bannerDetail = (data) => post("platform/banner/detail", data);

//数据字典
/**
 * 数据字典-参数名列表
 * @param {*} data 
 * @returns 
 */
const dictionaryParamlist = (data) => post("platform/dictionary/paramlist", data);
/**
 * 数据字典-参数值列表
 * @param {*} data 
 * @returns 
 */
const dictionaryValuelist = (data) => post("platform/dictionary/valuelist", data);
/**
 * 数据字典-新增编辑参数值信息
 * @param {*} data 
 * @returns 
 */
const dictionaryEditvalue = (data) => post("platform/dictionary/editvalue", data);
/**
 * 数据字典-批量、单个删除
 * @param {*} data 
 * @returns 
 */
const dictionaryDel = (data) => post("platform/dictionary/del", data);
//工作人员
/**
 * 工作人员-列表
 * @param {*} data 
 * @returns 
 */
const adminLst = (data) => post("platform/admin/lst", data);
/**
 * 工作人员-新增编辑信息
 * @param {*} data 
 * @returns 
 */
const adminEdit = (data) => post("platform/admin/edit", data);
/**
 * 工作人员-详情
 * @param {*} data 
 * @returns 
 */
const adminDetail = (data) => post("platform/admin/detail", data);
/**
 * 工作人员-批量、单个删除
 * @param {*} data 
 * @returns 
 */
const adminDel = (data) => post("platform/admin/del", data);
/**
 * 工作人员-批量、单个在职、离职
 * @param {*} data 
 * @returns 
 */
const adminSetstatus = (data) => post("platform/admin/setstatus", data);
/**
 * 工作人员-得到可选角色
 * @param {*} data 
 * @returns 
 */
const adminGetrole = (data) => post("platform/admin/getrole", data);
//角色管理
/**
 * 角色管理-角色及对应权限菜单
 * @param {*} data 
 * @returns 
 */
const authorizeLst = (data) => post("platform/authorize/lst", data);
/**
 * 角色管理-得到所有的系统权限
 * @param {*} data 
 * @returns 
 */
const authorizeGetallmenu = (data) => post("platform/authorize/getallmenu", data);
/**
 * 角色管理-新增编辑角色
 * @param {*} data 
 * @returns 
 */
const authorizeEdit = (data) => post("platform/authorize/edit", data);
/**
 * 角色管理-删除角色
 * @param {*} data 
 * @returns 
 */
const authorizeDel = (data) => post("platform/authorize/del", data);
/**
 * 角色管理-给相应角色分配菜单权限
 * @param {*} data 
 * @returns 
 */
const authorizeSetmenu = (data) => post("platform/authorize/setmenu", data);

/**
 * 课程评价-活动列表
 * @param {*} data 
 * @returns 
 */
const activityEvaluateactivitylist = (data) => post("platform/activity/evaluateactivitylist", data);
/**
 * 课程评价-课程列表
 * @param {*} data 
 * @returns 
 */
const activityEvaluatecourselist = (data) => post("platform/activity/evaluatecourselist", data);
/**
 * 课程评价-评价详情
 * @param {*} data 
 * @returns 
 */
const activityEvaluatedetail = (data) => post("platform/activity/evaluatedetail", data);

/**
 * 活动视频、酒店预定-活动列表
 * @param {*} data 
 * @returns 
 */
const videoActivitylist = (data) => post("platform/video/activitylist", data);
/**
 * 活动视频、酒店预定-视频记录
 * @param {*} data 
 * @returns 
 */
const videoLst = (data) => post("platform/video/lst", data);
/**
 * 活动视频、酒店预定-新增编辑视频
 * @param {*} data 
 * @returns 
 */
const videoVideoedit = (data) => post("platform/video/videoedit", data);
/**
 * 活动视频、酒店预定-视频详情
 * @param {*} data 
 * @returns 
 */
const videoVideodetail = (data) => post("platform/video/videodetail", data);
/**
 * 活动视频、酒店预定-视频删除
 * @param {*} data 
 * @returns 
 */
const videoVideodel = (data) => post("platform/video/videodel", data);
/**
 * 活动视频、酒店预定-得到酒店预定海报
 * @param {*} data 
 * @returns 
 */
const videoGethotel = (data) => post("platform/video/gethotel", data);
/**
 * 活动视频、酒店预定-设置酒店海报
 * @param {*} data 
 * @returns 
 */
const videoSethotel = (data) => post("platform/video/sethotel", data);

/**
 * 集采管理-集采列表
 * @param {*} data 
 * @returns 
 */
const jicaiLst = (data) => post("platform/jicai/lst", data);
/**
 * 集采管理-新增编辑
 * @param {*} data 
 * @returns 
 */
const jicaiEdit = (data) => post("platform/jicai/edit", data);
/**
 * 集采管理-详情
 * @param {*} data 
 * @returns 
 */
const jicaiDetail = (data) => post("platform/jicai/detail", data);
/**
 * 集采管理-删除（待发布时操作）
 * @param {*} data 
 * @returns 
 */
const jicaiDel = (data) => post("platform/jicai/del", data);
/**
 * 集采管理-批量发布（待发布时操作）
 * @param {*} data 
 * @returns 
 */
const jicaiSetrelease = (data) => post("platform/jicai/setrelease", data);
/**
 * 集采管理-批量结束（进行中时操作）
 * @param {*} data 
 * @returns 
 */
const jicaiSetover = (data) => post("platform/jicai/setover", data);
/**
 * 集采管理-进行中的集采撤回
 * @param {*} data 
 * @returns 
 */
const jicaiWithdraw = (data) => post("platform/jicai/withdraw", data);
/**
 * 集采管理-重新发布（已结束时操作）
 * @param {*} data 
 * @returns 
 */
const jicaiRerelease = (data) => post("platform/jicai/rerelease", data);
/**
 * 集采管理-报名人员列表
 * @param {*} data 
 * @returns 
 */
const jicaiSignupuserlist = (data) => post("platform/jicai/signupuserlist", data);

/**
 * 财务管理-财务明细
 * @param {*} data 
 * @returns 
 */
const financeFinancelist = (data) => post("platform/finance/financelist", data);

export default {
    indexLogin,
    indexSendcode,
    indexReset,
    indexUploadimg,
    indexUploadfile,
    indexGetinfo,
    indexEditinfo,
    indexLoginlog,

    activityActivitylist,
    activityActivitydetail,
    activityActivityedit,
    activityBanjiedit,
    activityBanjilist,
    activityBanjidetail,
    activityBanjidel,
    activityCourseedit,
    activityCoursedetail,
    activityCourselist,
    activityGetteacher,
    activityCoursedel,
    activityGrouplist,
    activitySetgroup,
    activityGroupedit,
    activityGroupdel,
    activityUnbindbanji,
    activityMovebanji,
    activitySaveactivity,
    activityReleaseactivity,
    activityAgainreleaseactivity,
    activityActivitydel,
    dictionaryGetactivitytype,
    dictionaryGetbanjitype,
    activityGroupbanjilist,
    activityGetinvite,
    activitySignupuserlist,
    activityImportsignup,
    activitySetusercheckin,
    dictionaryGetcancelreason,
    activityCancelsignup,
    activitySetqrcode,
    activityImportsignupnew,

    activityTasklist,
    activityTaskadd,
    activityTaskuserlist,
    activityUsertasklogdel,
    activityEditusertasklog,
    activityInvitelog,

    userUserlist,
    userUseredit,
    userUserdetail,
    userUserdel,
    userRolelist,
    userRoleedit,
    userRoledel,
    dictionaryGetgroup,
    userGetallmenu,
    userSetmenu,

    bannerLst,
    bannerEdit,
    bannerChangestatus,
    bannerDel,
    bannerDetail,

    dictionaryParamlist,
    dictionaryValuelist,
    dictionaryEditvalue,
    dictionaryDel,

    adminLst,
    adminEdit,
    adminDetail,
    adminDel,
    adminSetstatus,
    adminGetrole,
    authorizeLst,
    authorizeGetallmenu,
    authorizeEdit,
    authorizeDel,
    authorizeSetmenu,

    activityEvaluateactivitylist,
    activityEvaluatecourselist,
    activityEvaluatedetail,

    videoActivitylist,
    videoLst,
    videoVideoedit,
    videoVideodetail,
    videoVideodel,
    videoGethotel,
    videoSethotel,

    jicaiLst,
    jicaiEdit,
    jicaiDetail,
    jicaiDel,
    jicaiSetrelease,
    jicaiSetover,
    jicaiWithdraw,
    jicaiRerelease,
    jicaiSignupuserlist,

    financeFinancelist,





}